var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table',{ref:"tableRef",attrs:{"resource":_vm.resource,"columns":_vm.columns,"data-mapper":_vm.dataMapper,"stacked":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Bonus ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }